export class ProviderNoteDetailModel {
  providerNoteDetailId: number = 0;
  providerNoteId: number = 0;
  providerInvoiceDetailId: number = 0;
  conceptInvoicingId: number = 0;
  quantity: number = 0;
  ivaRate: number = 0;
  ivaBase: number = 0;
  totalValue: number = 0;
  createDate: Date | null = null;
  userNameCreate: string | null = null;
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
  // Solo se utiliza para mostrar la cantidad facturada
  articleCode: string = '';
  articleName: string = '';
  quantityInvoiced: number = 0;
  unitValueInvoiced: number = 0;
}
